import { render, staticRenderFns } from "./GenericFaqTabs.vue?vue&type=template&id=123582ed&scoped=true"
import script from "./GenericFaqTabs.vue?vue&type=script&lang=js"
export * from "./GenericFaqTabs.vue?vue&type=script&lang=js"
import style0 from "./GenericFaqTabs.vue?vue&type=style&index=0&id=123582ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123582ed",
  null
  
)

export default component.exports